import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { onMounted, toRefs } from 'vue';
import { LocationForm } from '@/components/Forms';
import { useOrganizationLocationStore, useOrganizationStore } from '@/store';
import { useToast } from 'primevue/usetoast';
import { LocationFormInterface } from '@/types';
import { can } from '@/composables';
import { PERMISSIONS } from '@/enum/permissions';


export default /*@__PURE__*/_defineComponent({
  __name: 'Location',
  props: {
  organizationId: {
    type: Number,
    default: null,
  },
},
  setup(__props) {

const toast = useToast();
const props = __props;

/**
 * Convert the properties into references.
 */
const { organizationId } = toRefs(props);

/**
 * All of the state references including the convertion of the
 * organization state object into a ref.
 */
const organizationLocationStore = useOrganizationLocationStore();
const organizationStore = useOrganizationStore();
/**
 * Initialize everything required to build out the component.
 */
onMounted(() => init());

/**
 * Initialize the organization location.
 */
const init = async () => {
  await organizationLocationStore.getLocation(organizationId.value);
};

const onSave = async (payload: LocationFormInterface) => {
  await organizationLocationStore.updateLocation(payload, organizationId.value);
  doToast(false);
};

/**
 * Display the toast message.
 * @param error:boolean
 */
const doToast = (error: boolean) => {
  toast.add({
    severity: error ? 'error' : 'success',
    summary: error ? 'Error' : 'Saved',
    detail: error ? 'There is an error with your form' : 'Organization Location information has been saved',
    life: 3000,
  });
};

/**
 * Handle the save and cancel event emitted by the child component
 * in order to reset the organization location data.
 */
const onReset = (data) => (organizationLocationStore.location = data);

return (_ctx: any,_cache: any) => {
  return (_unref(organizationStore).location)
    ? (_openBlock(), _createBlock(_unref(LocationForm), {
        key: 0,
        "permission-to-edit": _unref(can)([_unref(PERMISSIONS).LOCATIONS_UPDATE]),
        data: _unref(organizationStore).location,
        "is-organization": true,
        loading: _unref(organizationStore).loading,
        onSave: onSave,
        onCancel: onReset
      }, null, 8, ["permission-to-edit", "data", "loading"]))
    : _createCommentVNode("", true)
}
}

})